import { themr } from '@friendsofreactjs/react-css-themr';
import BioDetail from './BioDetail';
import style from './BioDetail.css';

export default themr('BioDetail', style)(BioDetail);
